import { createFileRoute } from '@tanstack/react-router';
import { Page } from '@trukt/ui/Page';
import JobCreateView from '../jobs/create/job-create-view';

const Component = () => <Page route={{ Component: JobCreateView }} />;

export const Route = createFileRoute('/orders/$orderGuid_/jobs/create')({ component: Component });
